package platform

import net.sergeych.mp_tools.decodeBase64
import net.sergeych.unikrypto.toUint8Array

actual fun unpackSmartContract(data: ByteArray): SmartContract {
    return ContractProxyJS(Uni.TransactionPack.unpack(data.toUint8Array()))
}
